module.exports = __webpack_public_path__ + "img/menu-on_03.04ebb70e.png";